import { formValueSelector } from 'redux-form';

import { INFERENTIAL_STATISTICS } from '../names';

const selector = formValueSelector(INFERENTIAL_STATISTICS);

const makeFieldValueGetter = field =>
  state => selector(state, field);

export const getSampleMean =
  makeFieldValueGetter('oneSampleT.sampleMean');

export const getStandardDeviation =
  makeFieldValueGetter('oneSampleT.standardDeviation');

export const getSampleSize =
  makeFieldValueGetter('oneSampleT.sampleSize');

export const getHypothesisMean =
  makeFieldValueGetter('hypothesisMean');

export const setAlternativeHypothesisMean =
  makeFieldValueGetter('alternativeHypothesis');

export const getProcedureOneSample =
  makeFieldValueGetter('procedureOneSample');

export const getNumericalRowDataSet =
  makeFieldValueGetter('oneSampleT.numericalRowDataSet');

export const getCategoricalRowDataSet =
  makeFieldValueGetter('oneSampleProportion.categoricalRowDataSet');

export const getInferentialStatistics =
  makeFieldValueGetter('inferentialStatistics');
